import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useCms } from '@/components/painel/cms/cms-context';
import { normalizeIdentity } from '@/lib/site-defaults';

/**
 * Aplica título/favicon da identidade do site no documento público.
 */
export function SiteIdentityHead() {
  const { site } = useCms();
  const identity = normalizeIdentity(site.identity);
  const favicon = identity.faviconUrl.trim() || '/favicon.ico';

  useEffect(() => {
    document
      .querySelectorAll<HTMLLinkElement>('link[rel="icon"], link[rel="shortcut icon"]')
      .forEach((el) => {
        el.href = favicon;
      });
  }, [favicon]);

  return (
    <Helmet>
      <link rel="icon" href={favicon} />
      <link rel="shortcut icon" href={favicon} />
    </Helmet>
  );
}
